import React from 'react';
import { Alert, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { FiInfo, FiUpload } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';
import TripCancellationResult from './TripCancellationResult';
import { isTripCancellationResponse } from '../../utils/tripCancellationResult';

const TripCancellationImportTab = ({
    partner,
    importFile,
    fileError,
    importLoading,
    result,
    fileAccept,
    columnHelp,
    businessAlert,
    onFileChange,
    onSubmit,
    onReset,
    onDismissResult,
}) => {
    const { t } = useTranslation();
    const prefix = `pages.adminTripsPoliciesCancelledImport.${partner}`;

    return (
        <>
            <Form onSubmit={onSubmit}>
                {businessAlert}
                <Alert variant="light" className="border mb-4">
                    <div className="d-flex align-items-start gap-2">
                        <FiInfo className="mt-1 flex-shrink-0" />
                        <div className="flex-grow-1">{columnHelp}</div>
                    </div>
                </Alert>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold" style={{ fontSize: '0.95rem', color: '#495057' }}>
                                {t(`${prefix}.fileLabel`)} <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="file"
                                accept={fileAccept}
                                isInvalid={!!fileError}
                                onChange={(e) => onFileChange(e.target.files?.[0] || null)}
                                disabled={importLoading}
                            />
                            <Form.Text className="text-muted">{t(`${prefix}.fileHint`)}</Form.Text>
                            {fileError && (
                                <Form.Control.Feedback type="invalid" className="d-block">
                                    {fileError}
                                </Form.Control.Feedback>
                            )}
                            {importFile && !fileError && (
                                <div className="mt-2 small text-success">
                                    ✓ {t(`${prefix}.fileSelected`, { name: importFile.name })}
                                </div>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
                <div className="d-flex justify-content-end gap-2 mt-4">
                    <Button variant="outline-secondary" type="button" onClick={onReset} disabled={importLoading}>
                        {t('common.reset')}
                    </Button>
                    <Button variant="primary" type="submit" disabled={importLoading || !importFile}>
                        {importLoading ? (
                            <>
                                <Spinner size="sm" className="me-2" animation="border" />
                                {t(`${prefix}.importing`)}
                            </>
                        ) : (
                            <>
                                <FiUpload className="me-2" />
                                {t(`${prefix}.importButton`)}
                            </>
                        )}
                    </Button>
                </div>
            </Form>

            {result && isTripCancellationResponse(result) && (
                <TripCancellationResult
                    partner={partner}
                    result={result}
                    onDismiss={onDismissResult}
                />
            )}
        </>
    );
};

export default TripCancellationImportTab;
